import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import questionMark from '../styles/img/question-mark.svg';
import { useDispatch, useSelector } from 'react-redux';
import PopupSample from '../components/Popup_sample';
import { createCart, getCartInfo } from '../actions/cartActions';
import useAxios from '../axios/useAxios';
import {
  ACCOUNT,
  HOME,
  LOGIN,
  NUMBER_SCREEN,
  SCAN,
  STORE_LIST,
} from '../constants/routes';
import StoreSelectionButton from '../components/button/StoreSelectionButton';
import SwipperTuto from '../components/Swipper';
import step1 from '../styles/img/tuto/step1.svg';
import step2 from '../styles/img/tuto/step2.svg';
import step3 from '../styles/img/tuto/step3.svg';
import { useUserLoginStatus } from '../utils/hooks';
import { isAppPWA } from '../utils/helper-functions';
import { FooterAccount } from '../components/footerAccount';
import ScanButton from '../components/button/ScanButton';
import { notifyDebugForm, notifyInfo } from '../utils/Notify';
import Lottie from 'lottie-react';
import confetti from 'canvas-confetti';
import { useTheme } from 'styled-components';
import { LottieLogo } from '../utils/LottieLogo';
import { useLocation } from 'react-router-dom';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { usePerformanceContext } from '../context/PerformanceContext';
import betaTicketIcon from '../components/betaUserForm/assets/svg/home-beta-user-ticket.svg';
import BetaUserBottomSheet from '../components/betaUserForm/BetaUserBottomSheet';
import clsx from 'clsx';
import { shouldShowWaitlistBottomSheet, setIsUserInWaitlistInLocalStorage } from '../utils/waitlist/useWaitlist';
import { prodBetaUserStore } from '../utils/waitlist/useWaitlist';
import { HomeDrawer } from '../components/phoneLogin/HomeDrawer';

const WelcomeScreen = () => {
  const [, setPlayAnimation] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { cartItems, loading } = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const theme = useTheme();
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPopup, setShowPopup] = useState(false);
  const [, setReset] = useState(false);
  const isLogged = user?._id;
  const isPWA = isAppPWA();
  const isUser = useUserLoginStatus();
  const { entryQr } = useLocation().state || localStorage.getItem('entryQr') || '';
  const [selectedItem, setSelectedItem] = useState(2);
  const { trackPageViewHome } = useFunnelTracking();
  const { markComplete } = usePerformanceContext();
  const [openBetaUserBottomSheet, setOpenBetaUserBottomSheet] = useState(false);
  const [, setShouldShowTicket] = useState(false);
  const [isAvailableStoreToJoinWaitlist, setIsAvailableStoreToJoinWaitlist] = useState(false);

  const isToolkitEnabled =
  process.env.REACT_APP_TOOLKIT?.toUpperCase() === 'TRUE';
  const isDevOrStageEnv = process.env.NODE_ENV === 'development' || isToolkitEnabled;
  const isOpenAndAvailableStoreToJoinWaitlist = openBetaUserBottomSheet && isAvailableStoreToJoinWaitlist;
  const isVisibleBetaUserBottomSheet = isOpenAndAvailableStoreToJoinWaitlist || isDevOrStageEnv;

  const handleDismissBetaUserBottomSheet = () => {
    setOpenBetaUserBottomSheet(false);
  };
  const handleTicketHide = () => {
    setShouldShowTicket(false);
    setIsUserInWaitlistInLocalStorage();
  };
  const initializationCompleted = useRef(false);
  const waitlistChecked = useRef(false);

  useEffect(() => {
    if (waitlistChecked.current) return;

    const checkWaitlist = async () => {
      try {
        const shouldShow = await shouldShowWaitlistBottomSheet(user);
        setShouldShowTicket(shouldShow);
      } catch (error) {
        console.error('Erreur lors de la vérification de la waitlist:', error);
      } finally {
        waitlistChecked.current = true;
      }
    };

    checkWaitlist();
  }, []);

  useEffect(() => {
    trackPageViewHome({});
  }, [trackPageViewHome]);

  const messageConnectionInscription = 'Me connecter / M\'inscrire';

  useEffect(() => {
    let isMounted = true;
    const initialize = () => {
      if (isMounted && !initializationCompleted.current) {
        setReset(true);
        if (!store || !store.name) {
          navigate(STORE_LIST, { state: { entryQr: entryQr || '' } });
        } else {
          initializationCompleted.current = true;
        }
      }
    };
    initialize();
    return () => {
      isMounted = false; // Cleanup function to ensure no updates after unmount
    };
  }, [store, navigate, entryQr]);

  useEffect(() => {
    if (store?.id) {
      setIsAvailableStoreToJoinWaitlist(Object.values(prodBetaUserStore).includes(store?.id));
    }
  }, [store]);

  function lancerConfettis() {
    return new Promise((resolve) => {
      const scalar = 5;
      const unicorn = confetti.shapeFromText({
                                               text: theme.confettis,
                                               scalar,
                                               fontFamily: 'Apple Color Emoji',
                                             });
      const defaults = {
      spread: 300,
      origin: { y: 0, x: 0.6 },
      shapes: [unicorn],
      scalar,
    };
      confetti({ ...defaults });

      setTimeout(resolve, 2000);
    });
  }

  useEffect(() => {
    const isPageFullyLoaded = store?.name && markComplete && axiosInstance && initializationCompleted.current && !loading;
    if (isPageFullyLoaded) {
      markComplete();
    }
  }, [store, axiosInstance, initializationCompleted, loading, markComplete]);

  useEffect(() => {
    let isMounted = true;

    const handleConfetti = async () => {
      if (isMounted && theme?.confettis) {
        await lancerConfettis();
      }
    };

    handleConfetti();

    return () => {
      isMounted = false;
    };
  }, [theme]);

  const deployScan = async () => {
    if (
      cartItems?.isPaid ||
      (!cartItems?._id && store?.id) ||
      (!localStorage.getItem('cartItems') && store?.id)
    ) {
      const orderCreate = {
        storeId: store?.id,
        clientId: user?._id || '',
        entryQr: entryQr,
      };

      try {
        dispatch(
          createCart(orderCreate, axiosInstance, () =>
            navigate(SCAN, { state: { entryQr: entryQr || '' } }),
          ),
        );
      } catch (e) {
        console.error('Error createCart', e);
      }
    } else if (cartItems?._id && localStorage.getItem('cartItems')) {
      navigate(SCAN);
    } else {
      notifyInfo('Il faut d\'abord choisir un magasin 😉');
      navigate(STORE_LIST, { state: { entryQr: entryQr || '' } });
    }
  };

  const tutoRef = useRef();
  const closepopup = () => {
    setShowPopup(false);
  };
  const [TutoCurrentIndex, setTutoCurrentIndex] = useState(0);
  const [view, setView] = useState(false);
  const onClickHelp = () => {
    setView(!view);
    setTutoCurrentIndex(0);
  };

  const pikkoAnim = useRef();
  const onClickNext = async () => {
    if (isPWA) {
      await deployScan();
    } else {
      navigate(ACCOUNT, { state: { prevPage: HOME } });
    }
  };

  useEffect(() => {
    const config = { threshold: 8, window: 2000 };
    let events = [];

    const processor = () => {
      const now = performance.now();
      events = events.filter(t => now - t < config.window);

      if (events.length >= config.threshold) {
        setTimeout(async () => {
          try {
            const result = await notifyDebugForm(axiosInstance, user, cartItems, dispatch);
            if (result.entryQr === 'debug') {
              dispatch(getCartInfo(cartItems?._id, axiosInstance));
              console.info('Debug mode activated');
            }
          } catch (error) {
            console.error('Debug activation failed:', error);
          }
        }, Math.random() * 100);
        events = [];
      }
    };

    const capture = (e) => {
      const target = e.target;
      if (target?.closest?.('#logo_pikko_welcome_screen')) {
        events.push(performance.now());
        requestAnimationFrame(processor);
      }
    };

    document.addEventListener('pointerdown', capture, { passive: true, capture: true });

    return () => document.removeEventListener('pointerdown', capture, { capture: true });
  }, []);

  const isLoggedIn = user?._id && user._id.length > 0;

  return (
    <>
      {!store || !store.name ? (
        <>
          <div
            className="absolute top-0 w-screen h-screen "
            style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
          >
            <div className="absolute  left-2/4 top-[25%]  -translate-x-2/4 ">
              <div className="lds-spinner white">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {showPopup ? (
            <PopupSample
              Title="Pikko Compte"
              Text="Crée ton compte PikkoPay et
          accède à de nombreux avantages !"
              List={[
                'Historique des tickets',
                'Points de fidélité',
                'Promotions exclusives',
              ]}
              Button={messageConnectionInscription}
              click={() => navigate(NUMBER_SCREEN)}
              close={closepopup}
            />
          ) : null}
          <div
            className={clsx(
              'welcome_screen_principal_container',
              isUser ? 'bg_background' : 'bg-gradient2',
              isPWA && 'pwa',
            )}
            >
            <img
              src={theme?.screenDecorations?.homeDecorationTop?.image}
              alt=""
              className="coco-leaf-right"
              style={theme?.screenDecorations?.homeDecorationTop?.style}
            />
            <img
              src={theme?.screenDecorations?.homeDecorationTop?.image}
              alt=""
              className="coco-leaf-left"
              style={theme?.screenDecorations?.homeDecorationTop?.style}
            />
            <div className="question-mark" onClick={onClickHelp} onKeyDown={onClickHelp} onKeyUp={onClickHelp} onKeyPress={onClickHelp}>
              <img src={questionMark} alt="" />
            </div>
            <SwipperTuto
              ref={tutoRef}
              close={onClickHelp}
              TutoCurrentIndex={TutoCurrentIndex}
              setTutoCurrentIndex={setTutoCurrentIndex}
              view={view}
              slides={[
                <div key="1" className="tuto_box">
                  <div className="tuto-container">
                    <img src={step1} alt="step1" />
                    <p className="tuto-bold">Scanne</p>
                    <div className="tuto-text">
                      <span className="tuto-title">
                        Scanne les codes barres de tes articles pour les ajouter
                        au panier
                      </span>
                    </div>
                  </div>
                </div>,
                <div key="2" className="tuto_box">
                  <div className="tuto-container">
                    <img src={step2} alt="step2" />
                    <p className="tuto-bold">Paye</p>
                    <div className="tuto-text">
                      <span className="tuto-title !max-w-[300px]">
                        Paye ton Pikko achat directement sur le smartphone sans
                        faire de queue
                      </span>
                    </div>
                  </div>
                </div>,
                <div key="3" className="tuto_box">
                  <div className="tuto-container">
                    <img src={step3} alt="step3" />
                    <p className="tuto-bold">Valide</p>
                    <div className="tuto-text">
                      <span className="tuto-title !max-w-[300px]">
                        Valide et dirige-toi vers la sortie express pour scanner
                        le QR code de sortie.
                      </span>
                    </div>
                  </div>
                </div>,
              ]}
            />

            <div
              className={
                isUser
                  ? 'bg-gradient2 welcome_screen_secondary_container'
                  : 'bg_background welcome_screen_secondary_container'
              }
            >
              <div>
                <div className="logo_and_welcome_text_container">
                  <div className="flex flex-col relative items-center justify-start" id="logo_pikko_welcome_screen">
                    {/*<div className="h-[30px] translate-y-[-40px]" >*/}
                    {/*  {isVisibleBetaUserBottomSheet && (*/}
                    {/*    <img src={betaTicketIcon} onClick={() => setOpenBetaUserBottomSheet(true)} onKeyDown={() => setOpenBetaUserBottomSheet(true)} onKeyUp={() => setOpenBetaUserBottomSheet(true)} onKeyPress={() => setOpenBetaUserBottomSheet(true)} alt="beta-ticket" className=" -top-10 left-0 balancing-ticket" />*/}
                    {/*  )}*/}
                    {/*</div>*/}

                    <Lottie
                      loop={LottieLogo[theme?.name]?.loop}
                      lottieRef={pikkoAnim}
                      autoPlay={true}
                      style={{
                        maxWidth: '80px',
                        height: '30dvh',
                        transform: 'translateY(20%)',
                        width: '100%',
                        minWidth: '80px',
                      }}
                      animationData={LottieLogo[theme?.name]?.image}
                      className="min-w-[80px] pointer-events-none"
                      onAnimationEnd={() => setPlayAnimation(false)}
                    />
                  </div>

                  <div className="welcome_text_container">
                    {isLogged ? (
                      <span className="welcome_text_container_bold">
                        Ravis de te revoir sur PikkoPay !
                      </span>
                    ) : (
                      <span className="welcome_text_container_bold">
                       Commence ton Pikko
                      </span>
                    )}
                  </div>
                </div>
                <StoreSelectionButton originPath={HOME} user={isLoggedIn}/>
              </div>
              <FooterAccount
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
              />

              <div
                className={
                  isPWA
                    ? 'connection_or_invitation pwa'
                    : 'connection_or_invitation'
                }
              >
                {' '}
                {user?._id && user._id.length > 0 ? (
                  <>
                    <ScanButton
                      onClick={onClickNext}
                      label={
                        loading ? (
                          <>Chargement ....</>
                        ) : (
                          <>
                            {isAppPWA() ? 'Scanner' : 'Voir mes points et scanner'}
                          </>
                        )
                      }
                      store={store}
                      editSelectedStore={() =>
                        navigate(STORE_LIST, { state: { prevPage: HOME } })
                      }
                    />
                    <FooterAccount
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                    />
                  </>
                ) : (
                  null
                )}
              </div>
            </div>
          </div>
          {isLoggedIn ? (
            null
          ) : <HomeDrawer />}
        </>
      )}
    </>
  );
};

export default WelcomeScreen;
